export default function ArrowDownIcon() {
	return (
		<svg style={{ width: '24px', height: '24px' }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
			<path d="M6 9L12 15L6 9ZM18 9L12 15L18 9Z" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
}
